import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaUser, FaSearch, FaBriefcase, FaFileUpload, FaCheck } from 'react-icons/fa';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const RegisterScout = () => {
  const [step, setStep] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [showLoader, setShowLoader] = useState(false);
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [verificationError, setVerificationError] = useState('');
  const navigate = useNavigate();

  const ghanaRegionsAndDistricts = {
    "Ahafo": ["Asunafo North", "Asunafo South", "Asutifi North", "Asutifi South", "Tano North", "Tano South"],
    "Ashanti": ["Adansi North", "Adansi South", "Afigya Kwabre", "Ahafo Ano North", "Ahafo Ano South", "Amansie Central", "Amansie West", "Asante Akim Central", "Asante Akim North", "Asante Akim South", "Atwima Kwanwoma", "Atwima Mponua", "Atwima Nwabiagya", "Bekwai", "Bosome Freho", "Bosomtwe", "Ejisu", "Ejura Sekyedumase", "Juaben", "Kumasi Metropolitan", "Kwabre East", "Mampong", "Obuasi", "Offinso", "Offinso North", "Sekyere Afram Plains", "Sekyere Central", "Sekyere East", "Sekyere Kumawu", "Sekyere South"],
    "Bono": ["Banda", "Berekum East", "Berekum West", "Dormaa Central", "Dormaa East", "Dormaa West", "Jaman North", "Jaman South", "Sunyani", "Sunyani West", "Tain", "Wenchi"],
    "Bono East": ["Atebubu-Amantin", "Kintampo North", "Kintampo South", "Nkoranza North", "Nkoranza South", "Pru East", "Pru West", "Sene East", "Sene West", "Techiman", "Techiman North"],
    "Central": ["Abura-Asebu-Kwamankese", "Agona East", "Agona West", "Ajumako-Enyan-Essiam", "Asikuma-Odoben-Brakwa", "Assin Central", "Assin North", "Assin South", "Awutu Senya East", "Awutu Senya West", "Cape Coast Metropolitan", "Effutu", "Ekumfi", "Gomoa Central", "Gomoa East", "Gomoa West", "Komenda-Edina-Eguafo-Abirem", "Mfantsiman", "Twifo-Ati Morkwa", "Twifo-Heman-Lower Denkyira", "Upper Denkyira East", "Upper Denkyira West"],
    "Eastern": ["Akuapim North", "Akuapim South", "Akyemansa", "Asuogyaman", "Atiwa East", "Atiwa West", "Ayensuano", "Birim Central", "Birim North", "Birim South", "Denkyembour", "Fanteakwa North", "Fanteakwa South", "Kwaebibirem", "Kwahu Afram Plains North", "Kwahu Afram Plains South", "Kwahu East", "Kwahu South", "Kwahu West", "Lower Manya Krobo", "New Juaben North", "New Juaben South", "Nsawam Adoagyiri", "Suhum", "Upper Manya Krobo", "Upper West Akim", "West Akim", "Yilo Krobo"],
    "Greater Accra": ["Ablekuma Central", "Ablekuma North", "Ablekuma West", "Ada East", "Ada West", "Adenta", "Ashaiman", "Ayawaso Central", "Ayawaso East", "Ayawaso North", "Ayawaso West", "Ga Central", "Ga East", "Ga North", "Ga South", "Ga West", "Korle Klottey", "Kpone Katamanso", "Krowor", "La Dadekotopon", "La Nkwantanang Madina", "Ledzokuku", "Ningo-Prampram", "Okaikwei North", "Sege", "Shai Osudoku", "Tema Metropolitan", "Tema West", "Weija Gbawe"],
    "North East": ["Bunkpurugu-Nakpanduri", "Chereponi", "East Mamprusi", "Mamprugu Moagduri", "West Mamprusi", "Yunyoo-Nasuan"],
    "Northern": ["Gushegu", "Karaga", "Kpandai", "Kumbungu", "Mion", "Nanton", "Nanumba North", "Nanumba South", "Saboba", "Sagnarigu", "Savelugu", "Tamale Metropolitan", "Tatale-Sanguli", "Tolon", "Yendi", "Zabzugu"],
    "Oti": ["Biakoye", "Jasikan", "Kadjebi", "Krachi East", "Krachi Nchumuru", "Krachi West", "Nkwanta North", "Nkwanta South"],
    "Savannah": ["Bole", "Central Gonja", "East Gonja", "North Gonja", "North East Gonja", "Sawla-Tuna-Kalba", "West Gonja"],
    "Upper East": ["Bawku Municipal", "Bawku West", "Binduri", "Bolgatanga East", "Bolgatanga Municipal", "Bongo", "Builsa North", "Builsa South", "Garu", "Kassena Nankana East", "Kassena Nankana West", "Nabdam", "Pusiga", "Talensi", "Tempane"],
    "Upper West": ["Daffiama-Bussie-Issa", "Jirapa", "Lambussie Karni", "Lawra", "Nadowli-Kaleo", "Nandom", "Sissala East", "Sissala West", "Wa East", "Wa Municipal", "Wa West"],
    "Volta": ["Adaklu", "Afadjato South", "Agotime Ziope", "Akatsi North", "Akatsi South", "Anloga", "Central Tongu", "Ho", "Ho West", "Hohoe", "Keta", "Ketu North", "Ketu South", "Kpando", "North Dayi", "North Tongu", "South Dayi", "South Tongu"],
    "Western": ["Ahanta West", "Amenfi Central", "Amenfi East", "Amenfi West", "Effia", "Ellembelle", "Jomoro", "Kwesimintsim", "Mpohor", "Nzema East", "Prestea-Huni Valley", "Sekondi-Takoradi Metropolitan", "Shama", "Tarkwa-Nsuaem", "Wassa Amenfi Central", "Wassa East"],
    "Western North": ["Aowin", "Bia East", "Bia West", "Bibiani-Anhwiaso-Bekwai", "Bodi", "Juaboso", "Sefwi Akontombra", "Sefwi Wiawso", "Suaman"]
  };

  const [formData, setFormData] = useState({
    // Personal Information
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    nationality: '',
    gender: '',
    // Location Information
    region: '',
    district: '',
    town: '',
    // Professional Information
    yearsOfExperience: '',
    previousClubs: '',
    specializations: [],
    certifications: '',
    // Contact Information
    phone: '',
    email: '',
    address: '',
    // Professional References
    reference1: {
      name: '',
      position: '',
      contact: '',
    },
    reference2: {
      name: '',
      position: '',
      contact: '',
    },
  });

  const steps = [
    { number: 1, title: "Personal Info", icon: <FaUser /> },
    { number: 2, title: "Professional Info", icon: <FaBriefcase /> },
    { number: 3, title: "References", icon: <FaSearch /> },
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleReferenceChange = (referenceNumber, field, value) => {
    setFormData(prev => ({
      ...prev,
      [`reference${referenceNumber}`]: {
        ...prev[`reference${referenceNumber}`],
        [field]: value
      }
    }));
  };

  const handleRegionChange = (e) => {
    const selectedRegion = e.target.value;
    setFormData(prev => ({
      ...prev,
      region: selectedRegion,
      district: '' // Reset district when region changes
    }));
  };

  const nextStep = () => {
    // Validate required fields in the current step before proceeding
    if (step === 1) {
      // Check if all personal information fields are filled
      const requiredFields = [
        'firstName', 
        'lastName', 
        'dateOfBirth', 
        'nationality', 
        'gender', 
        'email', 
        'phone', 
        'region', 
        'district', 
        'town'
      ];
      
      const missingFields = requiredFields.filter(field => !formData[field]);
      
      if (missingFields.length > 0) {
        alert('Please fill in all required fields in the Personal Information section.');
        return;
      }
    }
    
    setStep(prev => Math.min(prev + 1, steps.length));
  };

  const prevStep = () => {
    setStep(prev => Math.max(prev - 1, 1));
  };

  const verifyRegistration = async () => {
    setShowVerificationModal(true);
    setVerificationError('');
    
    try {
      const response = await axios.get(' https://ksa-manager-back.onrender.com/fetch_registered_players');
      
      if (response.data && response.data.success === true) {
        // If verification is successful, proceed with registration
        setShowVerificationModal(false);
        handleSubmit();
      } else {
        setVerificationError('Verification failed. Please try again.');
      }
    } catch (error) {
      console.error('Verification error:', error);
      setVerificationError('Failed to verify. Please try again.');
    }
  };

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      setShowLoader(true);
      setSubmitError('');

      // Format the data to match the API requirements
      const dataToSubmit = {
        first_name: formData.firstName,
        last_name: formData.lastName,
        date_of_birth: formData.dateOfBirth,
        nationality: formData.nationality,
        gender: formData.gender,
        region: formData.region,
        district: formData.district,
        town: formData.town,
        years_of_experience: parseInt(formData.yearsOfExperience),
        previous_clubs: formData.previousClubs,
        specializations: formData.specializations || [],
        certifications: formData.certifications,
        phone: formData.phone,
        email: formData.email,
        address: formData.address,
        reference1_name: formData.reference1.name,
        reference1_position: formData.reference1.position,
        reference1_contact: formData.reference1.contact,
        reference2_name: formData.reference2.name,
        reference2_position: formData.reference2.position,
        reference2_contact: formData.reference2.contact,
        registration_reference: `SR-${Math.floor(10000000 + Math.random() * 90000000)}`
      };

      // Send the data to the API
      const response = await axios.post(' https://ksa-manager-back.onrender.com/register_scout', dataToSubmit);

      if (response.data && response.data.message) {
        toast.success('Registration successful! Redirecting...', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        
        // Redirect to success page after a delay
        setTimeout(() => {
          navigate('/auth/success');
        }, 3000);
      }
    } catch (error) {
      console.error('Registration error:', error);
      const errorMessage = error.response?.data?.message || 'Failed to register. Please try again.';
      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } finally {
      setIsSubmitting(false);
      setShowLoader(false);
    }
  };

  return (
    <div className="min-h-screen relative">
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
      {/* Background Pattern */}
      <div className="fixed inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-gray-900 to-blue-900">
          <div className="absolute inset-0 opacity-5" 
               style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cpath d="M30 0L0 30h60L30 0zm0 60L60 30H0l30 30z" fill="%23ffffff" fill-opacity="0.4"/%3E%3C/svg%3E")',
                        backgroundSize: '30px 30px' }}>
          </div>
        </div>
      </div>

      <div className="relative z-10">
        <Header />

        {/* Hero Section */}
        <section className="py-12">
          <div className="container mx-auto px-4">
            <div className="flex flex-col lg:flex-row items-center gap-12 mb-12">
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                className="lg:w-1/2"
              >
                <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
                  Join Our Scouting Network
                </h1>
                <p className="text-xl text-blue-100 mb-8">
                  Become part of our elite scouting network and help discover the next generation of football talent.
                </p>
                <div className="flex flex-wrap gap-4">
                  <div className="flex items-center gap-2 text-blue-100">
                    <FaCheck className="text-green-400" />
                    <span>Global Network</span>
                  </div>
                  <div className="flex items-center gap-2 text-blue-100">
                    <FaCheck className="text-green-400" />
                    <span>Professional Development</span>
                  </div>
                  <div className="flex items-center gap-2 text-blue-100">
                    <FaCheck className="text-green-400" />
                    <span>Advanced Tools</span>
                  </div>
                </div>
              </motion.div>
              
              <motion.div
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                className="lg:w-1/2"
              >
                <div className="relative">
                  <motion.img
                    src="https://images.pexels.com/photos/3621104/pexels-photo-3621104.jpeg"
                    alt="Scouting Network"
                    className="rounded-2xl shadow-2xl w-full h-[400px] object-cover"
                    whileHover={{ scale: 1.02 }}
                    transition={{ duration: 0.3 }}
                  />
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.5 }}
                    className="absolute -bottom-6 -right-6 bg-blue-600 text-white p-4 rounded-lg shadow-lg"
                  >
                    <p className="text-sm font-semibold">Join Our Network</p>
                    <p className="text-xs opacity-80">Limited Positions Available</p>
                  </motion.div>
                </div>
              </motion.div>
            </div>

            {/* Requirements Section */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="max-w-4xl mx-auto bg-white/5 backdrop-blur-sm rounded-xl p-6 mb-12"
            >
              <h2 className="text-xl font-semibold text-white mb-4">Scout Requirements</h2>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="space-y-3">
                  <h3 className="text-blue-400 font-medium">Required Documents</h3>
                  <ul className="space-y-2 text-blue-100">
                    <li className="flex items-center gap-2">
                      <FaCheck className="text-green-400" />
                      Professional Certifications
                    </li>
                    <li className="flex items-center gap-2">
                      <FaCheck className="text-green-400" />
                      Background Check
                    </li>
                    <li className="flex items-center gap-2">
                      <FaCheck className="text-green-400" />
                      Professional References
                    </li>
                  </ul>
                </div>
                <div className="space-y-3">
                  <h3 className="text-blue-400 font-medium">Experience Requirements</h3>
                  <ul className="space-y-2 text-blue-100">
                    <li className="flex items-center gap-2">
                      <FaCheck className="text-green-400" />
                      Minimum 3 years experience
                    </li>
                    <li className="flex items-center gap-2">
                      <FaCheck className="text-green-400" />
                      Professional network
                    </li>
                    <li className="flex items-center gap-2">
                      <FaCheck className="text-green-400" />
                      Strong analytical skills
                    </li>
                  </ul>
                </div>
              </div>
            </motion.div>
          </div>
        </section>

        {/* Registration Form Section */}
        <section className="py-12 bg-white/5">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="text-center mb-12"
              >
                <h2 className="text-3xl font-bold text-white mb-4">Scout Registration Form</h2>
                <p className="text-xl text-blue-100">Please fill out all required information</p>
              </motion.div>

              {/* Progress Steps */}
              <div className="mb-12">
                <div className="flex justify-between items-center">
                  {steps.map((s, i) => (
                    <div key={s.number} className="flex-1 relative">
                      <div className="flex flex-col items-center">
                        <motion.div
                          initial={{ scale: 0.8 }}
                          animate={{ 
                            scale: step >= s.number ? 1 : 0.8,
                            backgroundColor: step >= s.number ? 'rgb(37, 99, 235)' : 'rgba(255, 255, 255, 0.1)'
                          }}
                          className={`w-12 h-12 rounded-full flex items-center justify-center text-white mb-2
                            ${step >= s.number ? 'bg-blue-600' : 'bg-white/10'}`}
                        >
                          {s.icon}
                        </motion.div>
                        <span className="text-sm text-white font-medium">{s.title}</span>
                      </div>
                      {i < steps.length - 1 && (
                        <div className={`absolute top-6 left-1/2 w-full h-0.5 
                          ${step > s.number ? 'bg-blue-600' : 'bg-white/10'}`}
                        ></div>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              {/* Form Container */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="bg-white/10 backdrop-blur-sm rounded-xl p-8"
              >
                <AnimatePresence mode='wait'>
                  <motion.div
                    key={step}
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -20 }}
                    transition={{ duration: 0.3 }}
                  >
                    {step === 1 && (
                      <div className="space-y-6">
                        <h2 className="text-2xl font-bold text-white mb-6">Personal Information</h2>
                        <div className="grid md:grid-cols-2 gap-6">
                          <div>
                            <label className="block text-blue-100 mb-2 text-sm">First Name</label>
                            <input
                              type="text"
                              name="firstName"
                              value={formData.firstName}
                              onChange={handleInputChange}
                              className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white focus:border-blue-400 focus:ring-blue-400"
                            />
                          </div>
                          <div>
                            <label className="block text-blue-100 mb-2 text-sm">Last Name</label>
                            <input
                              type="text"
                              name="lastName"
                              value={formData.lastName}
                              onChange={handleInputChange}
                              className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white focus:border-blue-400 focus:ring-blue-400"
                            />
                          </div>
                          <div>
                            <label className="block text-blue-100 mb-2 text-sm">Date of Birth</label>
                            <input
                              type="date"
                              name="dateOfBirth"
                              value={formData.dateOfBirth}
                              onChange={handleInputChange}
                              className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white focus:border-blue-400 focus:ring-blue-400"
                            />
                          </div>
                          <div>
                            <label className="block text-blue-100 mb-2 text-sm">Nationality</label>
                            <input
                              type="text"
                              name="nationality"
                              value={formData.nationality}
                              onChange={handleInputChange}
                              className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white focus:border-blue-400 focus:ring-blue-400"
                            />
                          </div>
                          <div>
                            <label className="block text-blue-100 mb-2 text-sm">Gender</label>
                            <select
                              name="gender"
                              value={formData.gender}
                              onChange={handleInputChange}
                              className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white focus:border-blue-400 focus:ring-blue-400 [&>option]:bg-gray-900"
                            >
                              <option value="">Select Gender</option>
                              <option value="male">Male</option>
                              <option value="female">Female</option>
                              <option value="other">Other</option>
                            </select>
                          </div>
                          <div>
                            <label className="block text-blue-100 mb-2 text-sm">Email Address</label>
                            <input
                              type="email"
                              name="email"
                              value={formData.email}
                              onChange={handleInputChange}
                              className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white focus:border-blue-400 focus:ring-blue-400"
                              placeholder="Your email address"
                            />
                          </div>
                          <div>
                            <label className="block text-blue-100 mb-2 text-sm">Contact Number</label>
                            <input
                              type="tel"
                              name="phone"
                              value={formData.phone}
                              onChange={handleInputChange}
                              className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white focus:border-blue-400 focus:ring-blue-400"
                              placeholder="Your phone number"
                            />
                          </div>
                          <div>
                            <label className="block text-blue-100 mb-2 text-sm">Region</label>
                            <select
                              name="region"
                              value={formData.region}
                              onChange={handleRegionChange}
                              className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white focus:border-blue-400 focus:ring-blue-400 [&>option]:bg-gray-900"
                            >
                              <option value="">Select Region</option>
                              {Object.keys(ghanaRegionsAndDistricts).map((region) => (
                                <option key={region} value={region}>
                                  {region}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div>
                            <label className="block text-blue-100 mb-2 text-sm">District</label>
                            <select
                              name="district"
                              value={formData.district}
                              onChange={handleInputChange}
                              className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white focus:border-blue-400 focus:ring-blue-400 [&>option]:bg-gray-900"
                              disabled={!formData.region}
                            >
                              <option value="">Select District</option>
                              {formData.region && ghanaRegionsAndDistricts[formData.region].map((district) => (
                                <option key={district} value={district}>
                                  {district}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div>
                            <label className="block text-blue-100 mb-2 text-sm">Town</label>
                            <input
                              type="text"
                              name="town"
                              value={formData.town}
                              onChange={handleInputChange}
                              className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white focus:border-blue-400 focus:ring-blue-400"
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    {step === 2 && (
                      <div className="space-y-6">
                        <h2 className="text-2xl font-bold text-white mb-6">Professional Information</h2>
                        <div className="grid md:grid-cols-2 gap-6">
                          <div>
                            <label className="block text-blue-100 mb-2 text-sm">Years of Experience</label>
                            <input
                              type="number"
                              name="yearsOfExperience"
                              value={formData.yearsOfExperience}
                              onChange={handleInputChange}
                              className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white focus:border-blue-400 focus:ring-blue-400"
                            />
                          </div>
                          <div>
                            <label className="block text-blue-100 mb-2 text-sm">Previous Clubs/Organizations</label>
                            <input
                              type="text"
                              name="previousClubs"
                              value={formData.previousClubs}
                              onChange={handleInputChange}
                              className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white focus:border-blue-400 focus:ring-blue-400"
                            />
                          </div>
                          <div>
                            <label className="block text-blue-100 mb-2 text-sm">Specializations</label>
                            <div className="space-y-2 bg-white/5 border border-white/10 rounded-lg p-4">
                              {[
                                { value: 'youth', label: 'Youth Development' },
                                { value: 'professional', label: 'Professional Level' },
                                { value: 'technical', label: 'Technical Analysis' },
                                { value: 'tactical', label: 'Tactical Analysis' }
                              ].map((option) => (
                                <label key={option.value} className="flex items-center space-x-2 text-white">
                                  <input
                                    type="checkbox"
                                    checked={formData.specializations.includes(option.value)}
                                    onChange={(e) => {
                                      const newSpecializations = e.target.checked
                                        ? [...formData.specializations, option.value]
                                        : formData.specializations.filter(v => v !== option.value);
                                      setFormData(prev => ({
                                        ...prev,
                                        specializations: newSpecializations
                                      }));
                                    }}
                                    className="rounded border-white/20 text-blue-600 focus:ring-blue-500"
                                  />
                                  <span>{option.label}</span>
                                </label>
                              ))}
                            </div>
                            {formData.specializations.length > 0 && (
                              <div className="mt-2">
                                <p className="text-xs text-blue-100">Selected: {formData.specializations.map(v => {
                                  const labels = {
                                    'youth': 'Youth Development',
                                    'professional': 'Professional Level',
                                    'technical': 'Technical Analysis',
                                    'tactical': 'Tactical Analysis'
                                  };
                                  return labels[v];
                                }).join(', ')}</p>
                              </div>
                            )}
                          </div>
                          <div>
                            <label className="block text-blue-100 mb-2 text-sm">Certifications</label>
                            <input
                              type="text"
                              name="certifications"
                              value={formData.certifications}
                              onChange={handleInputChange}
                              className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white focus:border-blue-400 focus:ring-blue-400"
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    {step === 3 && (
                      <div className="space-y-6">
                        <h2 className="text-2xl font-bold text-white mb-6">Professional References</h2>
                        <div className="space-y-6">
                          {/* Reference 1 */}
                          <div className="bg-white/5 rounded-lg p-6">
                            <h3 className="text-lg font-semibold text-white mb-4">Reference 1</h3>
                            <div className="grid md:grid-cols-2 gap-6">
                              <div>
                                <label className="block text-blue-100 mb-2 text-sm">Name</label>
                                <input
                                  type="text"
                                  value={formData.reference1.name}
                                  onChange={(e) => handleReferenceChange(1, 'name', e.target.value)}
                                  className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white focus:border-blue-400 focus:ring-blue-400"
                                />
                              </div>
                              <div>
                                <label className="block text-blue-100 mb-2 text-sm">Position</label>
                                <input
                                  type="text"
                                  value={formData.reference1.position}
                                  onChange={(e) => handleReferenceChange(1, 'position', e.target.value)}
                                  className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white focus:border-blue-400 focus:ring-blue-400"
                                />
                              </div>
                              <div className="md:col-span-2">
                                <label className="block text-blue-100 mb-2 text-sm">Contact Information</label>
                                <input
                                  type="text"
                                  value={formData.reference1.contact}
                                  onChange={(e) => handleReferenceChange(1, 'contact', e.target.value)}
                                  className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white focus:border-blue-400 focus:ring-blue-400"
                                />
                              </div>
                            </div>
                          </div>

                          {/* Reference 2 */}
                          <div className="bg-white/5 rounded-lg p-6">
                            <h3 className="text-lg font-semibold text-white mb-4">Reference 2</h3>
                            <div className="grid md:grid-cols-2 gap-6">
                              <div>
                                <label className="block text-blue-100 mb-2 text-sm">Name</label>
                                <input
                                  type="text"
                                  value={formData.reference2.name}
                                  onChange={(e) => handleReferenceChange(2, 'name', e.target.value)}
                                  className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white focus:border-blue-400 focus:ring-blue-400"
                                />
                              </div>
                              <div>
                                <label className="block text-blue-100 mb-2 text-sm">Position</label>
                                <input
                                  type="text"
                                  value={formData.reference2.position}
                                  onChange={(e) => handleReferenceChange(2, 'position', e.target.value)}
                                  className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white focus:border-blue-400 focus:ring-blue-400"
                                />
                              </div>
                              <div className="md:col-span-2">
                                <label className="block text-blue-100 mb-2 text-sm">Contact Information</label>
                                <input
                                  type="text"
                                  value={formData.reference2.contact}
                                  onChange={(e) => handleReferenceChange(2, 'contact', e.target.value)}
                                  className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white focus:border-blue-400 focus:ring-blue-400"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Navigation Buttons */}
                    <div className="flex justify-between mt-8">
                      {step > 1 && (
                        <motion.button
                          whileHover={{ scale: 1.05 }}
                          whileTap={{ scale: 0.95 }}
                          onClick={prevStep}
                          className="px-8 py-3 rounded-lg bg-white/10 text-white hover:bg-white/20 transition-colors duration-200"
                        >
                          Previous
                        </motion.button>
                      )}
                      <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        onClick={step === steps.length ? verifyRegistration : nextStep}
                        className={`px-8 py-3 rounded-lg ${
                          step === steps.length
                            ? 'bg-green-600 hover:bg-green-700'
                            : 'bg-blue-600 hover:bg-blue-700'
                        } text-white transition-colors duration-200 ml-auto`}
                      >
                        {step === steps.length ? 'Verify Registration' : 'Next'}
                      </motion.button>
                    </div>
                  </motion.div>
                </AnimatePresence>
              </motion.div>
            </div>
          </div>
        </section>

        <Footer />
      </div>

      {/* Loader Modal */}
      {showLoader && (
        <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-50 flex items-center justify-center">
          <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4 text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mx-auto mb-4"></div>
            <h3 className="text-xl font-semibold text-gray-800 mb-2">Wait Please</h3>
            <p className="text-gray-600">Your registration is being processed. Please do not close this page.</p>
          </div>
        </div>
      )}

      {/* Verification Modal */}
      {showVerificationModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>
          <div className="bg-white rounded-lg p-8 shadow-xl z-10 max-w-md w-full mx-4 text-center">
            <div className="flex flex-col items-center">
              <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-blue-500 mb-4"></div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Verifying Data</h3>
              <p className="text-gray-600 mb-4">Please wait while we verify your information...</p>
              
              {verificationError && (
                <div className="mb-4">
                  <p className="text-red-500 mb-4">{verificationError}</p>
                  <button
                    onClick={verifyRegistration}
                    className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                  >
                    Try Again
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Success Message */}
      {submitSuccess && (
        <div className="mt-4 p-4 bg-green-100 text-green-800 rounded-lg">
          <p className="flex items-center">
            <FaCheck className="mr-2" />
            Registration successful! Redirecting to success page...
          </p>
        </div>
      )}

      {/* Error Message */}
      {submitError && (
        <div className="mt-4 p-4 bg-red-100 text-red-800 rounded-lg">
          <p>{submitError}</p>
        </div>
      )}
    </div>
  );
};

export default RegisterScout; 